import React from 'react';
import PropTypes from 'prop-types';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';

const baseTheme = {
    shadows: ['none'],
    palette: {
        primary: {
            light: '#00A9D0',
            main: '#00FF00',
            dark: '#757575',
            contrastText: '#FF0000',
        },
        secondary: {
            light: '#e1e1e1',
            main: '#e1e1e1',
            dark: '#bbb',
            contrastText: '#444',
        },
    },
    props: {
        MuiButtonBase: {
            disableRipple: true,
        },
    },
    overrides: {
        MuiButton: {
            root: {
                borderRadius: '8px !important',
                fontFamily: 'Noto Sans',
                fontSize: 14,
                '&.Mui-disabled': {
                    color: '#E2E2E2 !important',
                    backgroundColor: '#F5F5F5 !important',
                },
            },
        },
    },
};

const ExplorerTheme = ({children, primaryColors}) => {
    baseTheme.palette.primary.main = primaryColors.background;
    baseTheme.palette.primary.contrastText = primaryColors.text;
    return <ThemeProvider theme={createTheme(baseTheme)}>{children}</ThemeProvider>;
};

ExplorerTheme.propTypes = {
    children: PropTypes.node.isRequired,
    primaryColors: PropTypes.object.isRequired,
};

export default ExplorerTheme;
